export const makeCurrencyFormatter = ({ currency_code, currency_minor_unit } = {
    currency_code: "EUR",
    currency_minor_unit: 2,
}) => {
    const formatter = new Intl.NumberFormat(process.env.NEXT_PUBLIC_LNG ?? "de", {
        style: "currency",
        currency: currency_code,
        minimumFractionDigits: currency_minor_unit,
        maximumFractionDigits: currency_minor_unit,
    });
    return (price = 0) => {
        const value = typeof price === "number" ? price : parseInt(price);
        return formatter.format(value / 100);
    };
};
//# sourceMappingURL=utils.js.map